<template>
  <section class="certified-section">
    <div class="section-container">

      <!-- 标题区域 -->
      <div class="header">
        <div class="tag">CREDENTIALS & ACCREDITATIONS</div>
        <h2 class="title">Certified & <span class="gradient">Professionally Verified</span></h2>

        <!-- 居中分割线 -->
        <div class="divider-container">
          <div class="line"></div>
          <span class="square-icon">[■]</span>
          <div class="line"></div>
        </div>
      </div>

      <!-- 卡片网格 -->
      <div class="grid">
        <div v-for="(cert, index) in certifications" :key="index" class="card">
          <!-- 圆形徽章区域 (黑科技风模拟) -->
          <div class="badge-wrap">
            <div class="badge-ring" :style="{ borderColor: cert.color, boxShadow: `0 0 15px ${cert.color}33` }"></div>
            <div class="badge-icon" :style="{ color: cert.color }">★</div>
          </div>

          <div class="cert-type" :style="{ color: cert.color }">{{ cert.type }}</div>
          <h3 class="cert-title">{{ cert.title }}</h3>

          <div class="inner-divider"></div>

          <div class="issuer">{{ cert.issuer }}</div>
          <div class="status" :style="{ color: cert.color }">ACTIVE</div>
        </div>
      </div>

    </div>
  </section>
</template>

<script>
export default {
  name: 'CertifiedSection',
  data() {
    return {
      certifications: [
        {
          type: 'Certificate of Excellence',
          title: 'Certified Blockchain Forensics Investigator',
          issuer: 'International Blockchain Security Institute',
          color: '#4fd1c5' // 淡青色
        },
        {
          type: 'Certificate of Compliance',
          title: 'Digital Forensics & Cyber Investigation',
          issuer: 'Global Cyber Forensics Authority',
          color: '#fbbf24' // 淡金黄色
        },
        {
          type: 'Elite Certification',
          title: 'Certified Digital Asset Recovery Expert',
          issuer: 'World Digital Asset Recovery Council',
          color: '#8be9fd' // 淡冰蓝色
        }
      ]
    };
  }
}
</script>

<style scoped>
.certified-section {
  background-color: #070b14;
  padding: 60px 5%;
  color: #e2e8f0;
}

.section-container {
  max-width: 1400px;
  margin: 0 auto;
}

/* 标题区域 */
.header {
  position: relative;
  margin-bottom: 50px;
}

.tag {
  color: #4fd1c5;
  font-size: 0.75rem;
  letter-spacing: 2px;
  margin-bottom: 10px;
  font-weight: 500;
}

.title {
  font-size: 2.5rem;
  /* 字体缩小 */
  font-weight: 700;
  margin: 0 0 20px;
}

/* 渐变文字颜色调淡 */
.gradient {
  background: linear-gradient(90deg, #4fd1c5, #8be9fd);
  -webkit-background-clip: text;
  color: transparent;
}

.divider-container {
  display: flex;
  align-items: center;
  width: 100%;
  margin-top: 10px;
}

.divider-container .line {
  flex: 1;
  height: 1px;
  background-color: rgba(79, 209, 197, 0.2);
  /* 淡色线 */
}

.divider-container .square-icon {
  color: #4fd1c5;
  font-size: 0.8rem;
  font-family: monospace;
  margin: 0 15px;
}

/* 卡片网格 */
.grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 25px;
}

/* 卡片样式 (黑科技淡色系) */
.card {
  background: rgba(13, 17, 23, 0.6);
  border: 1px solid rgba(37, 48, 69, 0.8);
  border-radius: 8px;
  padding: 40px 20px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  transition: all 0.3s ease;
}

.card:hover {
  border-color: #4fd1c5;
  transform: translateY(-5px);
  box-shadow: 0 10px 20px rgba(79, 209, 197, 0.1);
}

/* 徽章区域 */
.badge-wrap {
  position: relative;
  width: 70px;
  height: 70px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 25px;
}

.badge-ring {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  border: 2px solid #4fd1c5;
  border-radius: 50%;
  transform: scale(1.1);
}

.badge-icon {
  font-size: 2rem;
  z-index: 2;
  text-shadow: 0 0 15px currentColor;
}

/* 证书各项文字 (字号较小) */
.cert-type {
  font-size: 0.85rem;
  margin-bottom: 10px;
  letter-spacing: 1px;
}

.cert-title {
  font-size: 1.2rem;
  font-weight: 600;
  margin: 0 0 15px;
  color: #fff;
}

.inner-divider {
  width: 40%;
  height: 1px;
  background-color: rgba(255, 255, 255, 0.1);
  margin-bottom: 15px;
}

.issuer {
  color: #a0b3cc;
  font-size: 0.85rem;
  margin-bottom: 25px;
}

.status {
  font-size: 0.75rem;
  font-weight: 600;
  letter-spacing: 2px;
}

/* 响应式适配 */
@media (max-width: 900px) {
  .grid {
    grid-template-columns: 1fr;
    gap: 20px;
  }

  .title {
    font-size: 2rem;
  }
}
</style>